export class ComplianceError extends Error {
  public readonly id: string;
  public readonly name = this.name;
  public readonly code?: number;
  public readonly message: string;
  public readonly original: any;
  public readonly stack?: string;
  public readonly data?: any;

  constructor(message: any, code?: number, data?: any) {
    super();

    this.message = message
    this.code = code
    this.data = data

    if (Error.captureStackTrace) Error.captureStackTrace(this, ComplianceError);

  }
}

export class ComplianceErrorEmptyState extends ComplianceError {
    constructor(message?: string) {
      super(message);
    }
  }